<template>
    <div>
        <h2 class="ix-page-title-secondary">Composition</h2>
        <p class="ix-text-small ix-text-secondary">Le stock est porté par les composants.</p>

        <div class="alert alert-danger" v-if="globalError">{{ globalError }}</div>

        <div class="ix-table-box mb-2">
            <table class="ix-table ix-table-grouped">
                <thead>
                <tr>
                    <th rowspan="2" style="width: 30px;"></th>
                    <th rowspan="2">Composant</th>
                    <th rowspan="2" class="text-right" style="width: 120px;">Qté / kit</th>
                    <th rowspan="2">Unité</th>
                    <th rowspan="2" class="text-right">Stock dispo</th>
                    <th colspan="2" class="ix-col-group-title ix-col-group-start">Prix de revient</th>
                    <th colspan="2" class="ix-col-group-title ix-col-group-start">Prix tarif</th>
                    <th rowspan="2" style="width: 50px;"></th>
                </tr>
                <tr>
                    <th class="text-right ix-col-sub ix-col-group-start">Unitaire</th>
                    <th class="text-right ix-col-sub">Total</th>
                    <th class="text-right ix-col-sub ix-col-group-start">Unitaire</th>
                    <th class="text-right ix-col-sub">Total</th>
                </tr>
                </thead>
                <draggable v-model="components" tag="tbody" handle=".handle-line" v-if="!loading">
                    <tr v-for="(component, index) in components" is="article-kit-component-form"
                        v-bind:key="component.uniq"
                        :component="component"
                        :index="index"
                        :is-last="index === components.length - 1"
                        :autocomplete-route="autocompleteRoute"
                        :excluded-ids="excludedIds"
                        :errors="parsedErrors"
                        v-on:component-selected="checkIfNewRowNeeded($event)"
                        v-on:component-deleted="deleteRow($event)"
                    ></tr>
                </draggable>
                <tfoot v-if="selected.length">
                <tr>
                    <td colspan="5" class="text-right ix-text-bold">Total composants</td>
                    <td class="ix-col-group-start"></td>
                    <td class="text-right ix-text-bold">
                        <span v-if="draft.costTotal !== null">{{ draft.currency(draft.costTotal) }}</span>
                        <span v-else class="ix-text-orange" v-b-tooltip title="Un composant sans prix d'achat">Incomplet</span>
                    </td>
                    <td class="ix-col-group-start"></td>
                    <td class="text-right ix-text-bold">{{ draft.currency(draft.sellingTotal) }}</td>
                    <td></td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import ArticleKitComponentForm from "./ArticleKitComponentForm";
    import draft from './kitDraft';

    /**
     * La composition d'un kit, saisie dans le formulaire de l'article. L'état vit dans kitDraft,
     * que lit la synthèse de prix placée sous la tarification.
     *
     * @see docs/DRI/Phase2/articles-composes.md § 8.2
     */
    export default {
        name: 'article-kit-components-table-form',
        props: {
            oldComponents: { type: String, default: '[]' },
            autocompleteRoute: { type: String, required: true },
            kitId: { type: [Number, String], default: null },
            marginType: { type: [Number, String], default: 1 },
            errors: { type: [Object, Array], default: () => ({}) },
        },
        components: {
            ArticleKitComponentForm,
            draggable
        },
        data() {
            return {
                loading: true,
                draft,
            };
        },
        computed: {
            components: {
                get() {
                    return draft.components;
                },
                set(value) {
                    draft.components = value;
                },
            },
            parsedErrors() {
                return Array.isArray(this.errors) ? {} : this.errors;
            },
            globalError() {
                return this.parsedErrors.components ? this.parsedErrors.components[0] : null;
            },
            selected() {
                return draft.selected;
            },
            excludedIds() {
                const ids = this.selected.map(component => component.article_id);

                return this.kitId ? ids.concat([this.kitId]) : ids;
            },
        },
        methods: {
            addRow(row) {
                const label = row && row.article_id ? (row.number ? row.number + ' - ' : '') + (row.name || '') : '';

                this.components.push({
                    uniq: Math.random().toString(36).substr(2, 9),
                    article_id: row ? row.article_id : null,
                    label: label,
                    selected_label: label,
                    quantity: row ? row.quantity : '',
                    unit: row ? row.unit : null,
                    available_stock: row ? row.available_stock : null,
                    is_manage: row ? row.is_manage : true,
                    is_active: row ? row.is_active : true,
                    unit_cost: row ? row.unit_cost : null,
                    selling_price: row ? row.selling_price : null,
                });
            },
            deleteRow(index) {
                this.components.splice(index, 1);

                if (this.components.length === 0 || this.components[this.components.length - 1].article_id) {
                    this.addRow(null);
                }
            },
            checkIfNewRowNeeded(index) {
                if (index === this.components.length - 1) {
                    this.addRow(null);
                }
            },
        },
        mounted() {
            draft.marginType = parseInt(this.marginType) === 2 ? 2 : 1;
            draft.components = [];

            const rows = JSON.parse(this.oldComponents);

            (Array.isArray(rows) ? rows : []).forEach(row => this.addRow(row));
            this.addRow(null);
            this.loading = false;
        },
    }
</script>
